// @core/api/endpoints/booking/reject_booking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLifecycleResponse,
  RejectBookingRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Reject booking
 * Provider rejects a pending booking. Notifies the customer and processes any deposit refund.
 */
export async function RejectBooking(
  target_type: string,
  target_id: string,
  data: RejectBookingRequest,
  options?: RequestOptions
): Promise<BookingLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/:target_id/reject`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<BookingLifecycleResponse>(requestPath, data, requestOptions);
}
